import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-neebo",
  "use": "icon-neebo-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" id=\"icon-neebo\"><path d=\"M14 2c6.6 0 12 5.4 12 12 0 2.2-.6 4.3-1.7 6.2-.3.5-1 .7-1.6.4-.5-.3-.7-1-.4-1.6.9-1.5 1.4-3.2 1.4-5 0-5.3-4.3-9.7-9.7-9.7S4.3 8.7 4.3 14s4.3 9.7 9.7 9.7c1.9 0 3.7-.5 5.2-1.5.5-.3 1.3-.2 1.6.4.3.5.2 1.3-.4 1.6-1.8 1.1-4.1 1.8-6.4 1.8-6.6 0-12-5.4-12-12S7.4 2 14 2m0 5.8c3.4 0 6.2 2.8 6.2 6.2s-2.8 6.2-6.2 6.2-6.2-2.8-6.2-6.2 2.8-6.2 6.2-6.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol